"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapiCreateAuthTokenResponseToJSON = exports.CapiCreateAuthTokenResponseFromJSONTyped = exports.CapiCreateAuthTokenResponseFromJSON = exports.instanceOfCapiCreateAuthTokenResponse = void 0;
var runtime_1 = require("../runtime");
var CapiAuthTokenResponse_1 = require("./CapiAuthTokenResponse");
/**
 * Check if a given object implements the CapiCreateAuthTokenResponse interface.
 */
function instanceOfCapiCreateAuthTokenResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCapiCreateAuthTokenResponse = instanceOfCapiCreateAuthTokenResponse;
function CapiCreateAuthTokenResponseFromJSON(json) {
    return CapiCreateAuthTokenResponseFromJSONTyped(json, false);
}
exports.CapiCreateAuthTokenResponseFromJSON = CapiCreateAuthTokenResponseFromJSON;
function CapiCreateAuthTokenResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : (0, CapiAuthTokenResponse_1.CapiAuthTokenResponseFromJSON)(json['data']),
    };
}
exports.CapiCreateAuthTokenResponseFromJSONTyped = CapiCreateAuthTokenResponseFromJSONTyped;
function CapiCreateAuthTokenResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': (0, CapiAuthTokenResponse_1.CapiAuthTokenResponseToJSON)(value.data),
    };
}
exports.CapiCreateAuthTokenResponseToJSON = CapiCreateAuthTokenResponseToJSON;
